export * from "./AllEventsPage";
export * from "./AllNewsPage";
export * from "./SingleEventPage/SingleEventPage";
export * from "./SingleNewsPage/SingleNewsPage";
